import { useNavigate } from "react-router-dom";
import {
  StyledArrow,
  StyledBackBtn,
  StyledBtnText,
  StyledCircle,
} from "./BackButton.style";

export default function BackButton() {
  const navigate = useNavigate();
  return (
    <StyledBackBtn onClick={() => navigate(-1)}>
      <StyledCircle aria-hidden="true">
        <StyledArrow></StyledArrow>
      </StyledCircle>
      <StyledBtnText>صفحه قبل </StyledBtnText>
    </StyledBackBtn>
  );
}
